import { put } from 'redux-saga/effects';

import makeRequest from 'rdx/utils/makeRequest';
import putErrorActions from 'rdx/utils/putErrorActions';
import { setStepReports } from 'rdx/modules/steps/slice';

function* getStepReports({ payload: { link, params = {}, query = {}, onSuccess, onError } }) {
  const { success, error, data } = yield* makeRequest.link(link, params, query);
  if (success && data) {
    if (onSuccess) {
      onSuccess();
    }
    yield put(setStepReports(data));
  }
  if (error) {
    if (onError) {
      onError();
    }
    yield* putErrorActions({ error });
  }
  return null;
}

export default getStepReports;
